module.exports = __webpack_public_path__ + "static/media/truck_1t_mini.e0b06834.svg";